import { useReferentialsFindAll } from '@api/WhisApi/generated';
import { buildReportFiltersConfig } from '@components/ReportFilters/reportFilters.config';
import type { ReportFiltersConfig } from '@components/ReportFilters/reportFilters.types';
import { useAppTranslation } from '@hooks/useAppTranslation';
import { useAuth } from '@hooks/useAuth';
import { useMemo } from 'react';

interface UseReportFiltersConfigResult {
  config: ReportFiltersConfig;
  isLoading: boolean;
}

export const useReportFiltersConfig = (): UseReportFiltersConfigResult => {
  const { t, language } = useAppTranslation();
  const { isAuthenticated } = useAuth();

  const { data: referentials, isPending } = useReferentialsFindAll({
    query: {
      enabled: isAuthenticated,
      staleTime: 5 * 60 * 1000,
    },
  });

  const config = useMemo(
    () => buildReportFiltersConfig(t, language, referentials),
    [language, referentials, t],
  );

  return { config, isLoading: isPending };
};
